// The variables a client file reads (ARCH-17). Next inlines each one at build time, so every getter names its variable
// in full. A getter reads the value when it is used, as the call sites did, so a test's vi.stubEnv still applies.
export const publicEnv = {
    get amplitudeApiKey() {
        return process.env.NEXT_PUBLIC_AMPLITUDE_API_KEY
    },
    get appVersion() {
        return process.env.NEXT_PUBLIC_APP_VERSION
    },
    get availableMetabaseDashboardIds() {
        return process.env.NEXT_PUBLIC_AVAILABLE_METABASE_DASHBOARD_IDS
    },
    get baseApiUrl() {
        return process.env.NEXT_PUBLIC_BASE_API_URL
    },
    get csvImportsClientIds() {
        return process.env.NEXT_PUBLIC_CSV_IMPORTS_CLIENT_IDS
    },
    get defaultMetabaseDashboardId() {
        return process.env.NEXT_PUBLIC_DEFAULT_METABASE_DASHBOARD_ID
    },
    get docusignAccountId() {
        return process.env.NEXT_PUBLIC_DOCUSIGN_ACCOUNT_ID
    },
    get docusignBaseUrl() {
        return process.env.NEXT_PUBLIC_DOCUSIGN_BASE_URL
    },
    get docusignClickwrapIdEn() {
        return process.env.NEXT_PUBLIC_DOCUSIGN_CLICKWRAP_ID_EN
    },
    get docusignClickwrapIdFr() {
        return process.env.NEXT_PUBLIC_DOCUSIGN_CLICKWRAP_ID_FR
    },
    get docusignIntegrationKey() {
        return process.env.NEXT_PUBLIC_DOCUSIGN_INTEGRATION_KEY
    },
    get environment() {
        return process.env.NEXT_PUBLIC_ENVIRONMENT
    },
    get faroAppNamespace() {
        return process.env.NEXT_PUBLIC_FARO_APP_NAMESPACE
    },
    get faroUrl() {
        return process.env.NEXT_PUBLIC_FARO_URL
    },
    get hasBeneficiaryLimits() {
        return process.env.NEXT_PUBLIC_HAS_BENEFICIARY_LIMITS
    },
    get hasNewNavigation() {
        return process.env.NEXT_PUBLIC_HAS_NEW_NAVIGATION
    },
    get hasProofs() {
        return process.env.NEXT_PUBLIC_HAS_PROOFS
    },
    get hasRepayments() {
        return process.env.NEXT_PUBLIC_HAS_REPAYMENTS
    },
    get hasRequirementsPortalLink() {
        return process.env.NEXT_PUBLIC_HAS_REQUIREMENTS_PORTAL_LINK
    },
    get hasSddRepayments() {
        return process.env.NEXT_PUBLIC_HAS_SDD_REPAYMENTS
    },
    get metabaseBaseUrl() {
        return process.env.NEXT_PUBLIC_METABASE_BASE_URL
    },
    get mock() {
        return process.env.NEXT_PUBLIC_MOCK
    },
    get sandbox() {
        return process.env.NEXT_PUBLIC_SANDBOX
    },
    get nodeEnv() {
        return process.env.NODE_ENV
    }
}
